import React from "react";
import { Link } from "react-router-dom";
import videoHome from "../videos/video_app_catalogo_web.mp4";

import btnViewer from "../images/btn_realtime.png";
import btnUpload from "../images/btn_upload.png";
import btnGuida from "../images/btn_guida.png";

import "./Home.css";

function Home() {
  return (
    <div className="home-page">
      {/* Image buttons */}
      <div className="home-buttons">
        <Link to="/viewer">
          <img src={btnViewer} alt="Viewer" className="home-btn-img" />
        </Link>
        <Link to="/upload">
          <img src={btnUpload} alt="Upload" className="home-btn-img" />
        </Link>
        <Link to="/guida">
          <img src={btnGuida} alt="Guida" className="home-btn-img" />
        </Link>
      </div>

      {/* Video */}
      <div className="video-container">
        <video controls className="video-player">
          <source src={videoHome} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      </div>
    </div>
  );
}

export default Home;
